import { AppAction, SettingsType } from '../constants/enums'
import { FULL_WINDOW_CLASS } from '../constants/video'
import { COLOR_SCHEME_TYPES } from '../mfcLogic/ueopts'
import { LAYOUTSTATE, updateLayoutState } from '../state/state.layout'
import { AppRouter } from '../state/state.router'
import { SETTINGSSTATE } from '../state/state.settings'
import { closeWhiteboard } from '../state/state.whiteboard'
import { event } from '../utilities/analytics'
import { motionTransition } from '../utilities/transitions'
import { setColorScheme } from './app'
import { saveSettings } from './settings'
import { appAction } from './workerActions'

export const transitionNavLayout = (expandedNav: boolean) => {
    motionTransition(() => {
        updateLayoutState({
            expandedNav: !expandedNav,
        })
    })
}

export const setChatMinimized = (minimized: boolean) => {
    updateLayoutState({ minimized })
}

export const setFullWindow = (fullWindow: boolean, saveSetting?: boolean) => {
    appAction(AppAction.FULL_WINDOW, fullWindow)

    const { fullWindow: fullWindowState } = LAYOUTSTATE.layout
    const { fullWindow: fullWindowSetting } =
        SETTINGSSTATE[SettingsType.DEFAULT]
    if (fullWindow !== fullWindowState) {
        if (!fullWindow) closeWhiteboard()
        updateLayoutState({
            fullWindow,
            ...(!fullWindow ? { minimized: false } : {}),
        })
        if (fullWindow) {
            document.body.classList.remove(FULL_WINDOW_CLASS)
            document.body.classList.add(FULL_WINDOW_CLASS)
            setColorScheme(COLOR_SCHEME_TYPES.dark)
        } else {
            document.body.classList.remove(FULL_WINDOW_CLASS)
            const colorSchemeSetting =
                SETTINGSSTATE[SettingsType.DEFAULT].colorScheme
            setColorScheme(colorSchemeSetting)
        }
    }
    if (saveSetting && fullWindow !== fullWindowSetting) {
        const resolvedPath = AppRouter.route.visiblePage.replace(
            'message',
            'pm',
        )
        event({
            action: `${resolvedPath}_full_window_mode_enabled_${fullWindow}`,
            category: 'user_interactions',
            label: 'interaction',
            value: fullWindow,
        })
        saveSettings(SettingsType.DEFAULT, 'fullWindow', fullWindow)
    }
}

export const onRouteChangeFullWindow = (url: string) => {
    const isRoomPage = url.startsWith('/room/')
    const isMessagePage = url.startsWith('/message/')
    if (!isRoomPage && !isMessagePage) {
        setFullWindow(false)
    }
}
